<template>
  <!-- 技术、技术商务评分汇总保存页 技术、技术商务公用一个保存页-->
  <div class="position-ab">
    <div class="ccui-app-box-iframe-operate-container">
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
      <div class="ccui-app-iframe-container-detail">
        <div class="ccui-app-iframe-container-detail-body">
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini">
                {{ tabName }}
              </el-button>
            </div>
            <template v-if="!isRemoveMaxAndMin && isCheckedHighAndLow">
              <div class="fr remarkTip">
                少于5个专家提交评分，系统不再进行去掉最低分和最高分操作
              </div>
              <div class="clearfix"></div>
            </template>
          </div>
          <!--        <el-tabs class="el-tabs__customize" value="1">-->
          <!--          <el-tab-pane-->
          <!--            :label="-->
          <!--              `${type == 0 ? '技术评分汇总' : '商务技术评分汇总'}${-->
          <!--                subPackageFlag == '0' ? '' : '(包件：' + packName + ')'-->
          <!--              }`-->
          <!--            "-->
          <!--            name="1"-->
          <!--          >-->
          <el-table ref="table" :data="listData" border>
            <el-table-column
              v-for="(item, index) in columns"
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
              :min-width="item.width"
            >
              <template slot="header">
                <template v-if="item.required">
                  <span class="star">*</span>{{ item.label }}
                </template>
                <template v-else>
                  {{ item.label }}
                </template>
              </template>
              <template v-if="item.labelChild && item.labelChild.length > 0">
                <el-table-column
                  v-for="(child, indexch) in item.labelChild"
                  :key="indexch"
                  align="center"
                  v-bind="child"
                >
                  <template slot="header">
                    <div class="el-tooltip" style="width: 130px">
                      {{ child.label }}
                    </div>
                  </template>
                  <template
                    v-if="child.labelChild && child.labelChild.length > 0"
                  >
                    <el-table-column
                      v-for="(childs, indexch) in child.labelChild"
                      :key="indexch"
                      align="center"
                      :prop="childs.prop"
                    >
                      <template slot="header">
                        <div
                          :title="childs.label"
                          class="el-tooltip tooltip-header"
                          :class="{
                            'tooltip-header-flow': childs.label.length > 15
                          }"
                        >
                          {{ childs.label }}
                        </div>
                      </template>
                    </el-table-column>
                  </template>
                </el-table-column>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-if="item.type == 'select' && type == '0'"
                  v-model="scope.row[item.prop]"
                >
                  <el-option value="1" label="淘汰"></el-option>
                  <el-option value="0" label="不淘汰"></el-option>
                </el-select>
                <el-input
                  maxlength="1000"
                  show-word-limit
                  class="input-short word-limit input-width;"
                  v-else-if="item.type == 'input' && type == '0'"
                  v-model="scope.row[item.prop]"
                ></el-input>
                <span v-else-if="item.money">{{
                  scope.row[item.prop] || scope.row[item.prop] === 0
                    ? new BigNumber(scope.row[item.prop]).toFormat(2)
                    : ""
                }}</span>
                <el-button
                  v-else-if="item.type == 'AIbtn'"
                  size="mini"
                  type="text"
                  @click="toAI(scope.row)"
                  >{{
                    scope.row[item.prop]
                      ? new BigNumber(scope.row[item.prop]).toFormat(2)
                      : ""
                  }}</el-button
                >
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
          <!--          </el-tab-pane>-->
          <!--        </el-tabs>-->
        </div>
      </div>
      <div class="operate">
        <el-button
          type="text"
          icon="icon-ccui-save"
          v-preventReClick
          @click="save"
          >保存</el-button
        >
        <el-button type="text" icon="icon-ccui-cancel" @click="back"
          >取消</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qrySumScoreCalculateApi,
  dealSumScoreSaveApi,
  listPurchaseSchemePackageApi,
  qryScoreListApi
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import { Loading } from "ccui";

export default {
  name: "operateSkillOrCommonSummary",
  components: {
    breadcrumbSourcing
  },
  data() {
    return {
      BigNumber: BigNumber,
      breadcrumbData: {
        titname:
          this.$router.history.current.query.type == 0
            ? "技术评分汇总"
            : "商务技术评分汇总"
      },
      type: this.$router.history.current.query.type, // 0：技术汇总 1：商务技术汇总1
      listData: [],
      skillHeaders: [],
      commonHeader: [],
      supScoreIds: [],
      columns: [],
      columnCopy: [
        {
          prop: "id",
          label: "序号",
          width: 55
        },
        {
          prop: "supName",
          label: "供应商",
          width: 200
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术",
          labelChild: [],
          align: "center"
        },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 110,
          align: "center",
          money: true
        }
        // {
        //   prop: "aiSumScore",
        //   label: "AI打分汇总",
        //   width: 110,
        //   type: "AIbtn"
        // }
        // {
        //   prop: "lostFlag",
        //   label: "是否淘汰",
        //   width: 110,
        //   type: "select",
        //   required: true
        // },
        // {
        //   prop: "lostReason",
        //   label: "淘汰理由",
        //   width: 350,
        //   type: "input",
        //   required: true
        // }
      ],
      packName: "",
      subPackageFlag: "1", // 是否分包 1分包0不分包
      isRemoveMaxAndMin: false,
      tabName: "",
      isCheckedHighAndLow: false // 是否选中了去除技术评分的最高最低
    };
  },
  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      this.columnCopy.splice(5, 1);
      this.columns = this.columnCopy;
    } else {
      this.columns = this.columnCopy;
    }
    this.getData();
    this.getPackData();
  },
  methods: {
    getData() {
      qryScoreListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        if (res.data.data) {
          this.isCheckedHighAndLow = res.data.data.sumForm === "102";
        }
      });
      let loadingObj = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
      qrySumScoreCalculateApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        packId: this.$router.history.current.query.packId,
        scoreItem: this.$router.history.current.query.type == 1 ? "" : "0"
      })
        .then(res => {
          if (res.data.data) {
            this.isRemoveMaxAndMin = res.data.data.isRemoveMaxAndMin;
          }
          if (
            res.data.data &&
            res.data.data.sscSumScoreCalculateBOS &&
            res.data.data.sscSumScoreCalculateBOS.length > 0
          ) {
            if (this.type == 1) {
              if (this.purchaseType == "50" || this.purchaseType == "53") {
                this.columns.splice(6, 0, {
                  prop: "sscCommonScoreItemBOS",
                  label: "商务",
                  labelChild: [],
                  align: "center"
                });
              } else {
                this.columns.splice(7, 0, {
                  prop: "sscCommonScoreItemBOS",
                  label: "商务",
                  labelChild: [],
                  align: "center"
                });
              }
            } else {
              this.columns.push(
                {
                  prop: "lostFlag",
                  label: "是否淘汰",
                  width: 110,
                  type: "select",
                  required: true
                },
                {
                  prop: "lostReason",
                  label: "淘汰理由",
                  width: 350,
                  type: "input",
                  required: true
                }
              );
            }
            let labelChild = []; // 商务
            let labelSkillChild = []; // 技术
            res.data.data.sscSumScoreCalculateBOS.forEach((item, index) => {
              item.lostFlag =
                item.lostFlag === "" || item.lostFlag === undefined ? "0" : "1";
              item.id = index + 1;
              item.sscSupScoreBOS.forEach(aItem => {
                aItem.sscSupScoreItemBOS.forEach(bItem => {
                  if (!bItem.supScore) {
                    bItem.supScore = 0;
                  }
                  item.scoreRule = bItem.scoreRule;
                  let props =
                    "supScore-" + aItem.scoreItem + "-" + bItem.scoreItemId;
                  item[props] = bItem.supScore
                    ? new BigNumber(bItem.supScore).toFormat(2)
                    : bItem.supScore;
                  if (this.type == 1) {
                    if (aItem.scoreItem === "1") {
                      if (
                        labelChild.filter(item => {
                          return (
                            item.prop ==
                            "supScore-" +
                              aItem.scoreItem +
                              "-" +
                              bItem.scoreItemId
                          );
                        }).length == 0
                      ) {
                        labelChild.push({
                          prop: props,
                          label: bItem.scoreRule,
                          width: 120,
                          type: "input",
                          labelChild: [
                            {
                              prop: props,
                              label: "细则权重:" + bItem.scoreWeight,
                              width: 280,
                              money: true
                            }
                          ]
                        });
                      }
                    }
                  }
                  if (aItem.scoreItem === "0") {
                    if (
                      labelSkillChild.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            aItem.scoreItem +
                            "-" +
                            bItem.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelSkillChild.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + bItem.scoreWeight,
                            width: 280,
                            money: true
                          }
                        ]
                      });
                    }
                  }
                });
              });
            });
            if (this.purchaseType == "50" || this.purchaseType == "53") {
              this.columns[5].labelChild = labelSkillChild;
              if (this.type == 1) {
                this.columns[6].labelChild = labelChild;
              }
            } else {
              this.columns[6].labelChild = labelSkillChild;
              if (this.type == 1) {
                this.columns[7].labelChild = labelChild;
              }
            }

            this.supScoreIds = res.data.data.supScoreIds;
            this.listData = res.data.data.sscSumScoreCalculateBOS;
            console.log(this.listData);
            // this.columns.push({
            //   prop: "aiSumScore",
            //   label: "AI打分汇总",
            //   width: 110,
            //   type: "AIbtn"
            // });
            this.$nextTick(() => {
              this.$refs.table.doLayout();
              loadingObj.close();
            });
          }
        })
        .catch(err => {
          loadingObj.close();
        });
    },
    getPackData() {
      listPurchaseSchemePackageApi({
        pageNo: 1,
        pageSize: 100,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag = res.data.data.subPackageFlag;
        let packId = this.$router.history.current.query.packId;
        res.data.data.purchaseSchemePackageList.forEach(item => {
          if (item.packId == packId) {
            this.packName = item.packName;
          }
        });
        let name = this.subPackageFlag == "1" ? `(包件：${this.packName})` : "";
        this.$set(
          this,
          "tabName",
          `${this.type == 0 ? "技术评分汇总" : "商务技术评分汇总"}${name}`
        );
      });
    },
    toAI(row) {
      let baseUrl = "http://47.108.13.132:8102";
      if (window.location.host.indexOf("local") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("test01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("uat01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else {
        baseUrl = "https://aimarket.iccec.cn";
      }
      window.open(
        baseUrl +
          "/front/supplyChain/summaryResults?taskId=" +
          row.taskId +
          "&editable=false&step=1&token=" +
          sessionStorage.getItem("AItoken"),
        "_blank"
      );
    },
    save() {
      let sscSupScoreSumBOS = [];
      let flag = true;
      let message = "";
      try {
        this.listData.forEach((item, index) => {
          console.log(item.lostFlag);
          if (this.type == "0") {
            if (item.lostFlag === "" || item.lostFlag === undefined) {
              flag = false;
              message = "第" + (index + 1) + "行的是否淘汰不能为空！";
              throw Error();
            }
            if (!item.lostReason && item.lostFlag == 1) {
              flag = false;
              message = "第" + (index + 1) + "行的淘汰理由不能为空！";
              throw Error();
            }
          }
          let obj = {};
          obj.supCode = item.supCode;
          obj.supName = item.supName;
          obj.supScore = item.supScore;
          obj.lostFlag = item.lostFlag;
          obj.lostReason = item.lostReason;
          obj.busiSumScore = 0;
          obj.techSumScore = 0;
          obj.sscSupScoreSumItemBOS = [];
          obj.sumScore = item.supScore;
          item.sscSupScoreBOS.forEach(sscSupScoreBO => {
            sscSupScoreBO.sscSupScoreItemBOS.forEach(sscSupScoreItemBO => {
              let sscSupScoreSumItemBO = {};
              sscSupScoreSumItemBO.scoreItem = sscSupScoreBO.scoreItem;
              sscSupScoreSumItemBO.scoreItemId = sscSupScoreItemBO.scoreItemId;
              sscSupScoreSumItemBO.scoreRule = sscSupScoreItemBO.scoreRule;
              sscSupScoreSumItemBO.supScore = sscSupScoreItemBO.supScore;
              if (sscSupScoreBO.scoreItem === "0") {
                obj.techSumScore += sscSupScoreItemBO.supScore;
              }
              if (sscSupScoreBO.scoreItem === "1") {
                obj.busiSumScore += sscSupScoreItemBO.supScore;
              }
              obj.sscSupScoreSumItemBOS.push(sscSupScoreSumItemBO);
            });
          });
          sscSupScoreSumBOS.push(obj);
        });
      } catch (e) {
        console.log(e);
      }
      if (flag) {
        let param = {
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.$router.history.current.query.packId,
          supScoreIds: this.supScoreIds,
          sumScoreType: this.type == 0 ? 0 : 2,
          sscSupScoreSumBOS: sscSupScoreSumBOS
        };
        dealSumScoreSaveApi(param).then(res => {
          if (res.data.code == "0") {
            this.$router.push({
              name:
                this.type == 1
                  ? "summaryBusinessSkillsScores"
                  : "technicalScoreSummary",
              query: {
                a: this.$router.history.current.query.a,
                menuKey: this.$router.history.current.query.menuKey,
                active: this.$route.query.active
              }
            });
            this.$message({
              message: "保存成功",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        });
      } else {
        this.$message({
          message: message,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    back() {
      console.log(this.type);
      this.$router.push({
        name:
          this.type == 1
            ? "summaryBusinessSkillsScores"
            : "technicalScoreSummary",
        query: {
          a: this.$router.history.current.query.a,
          menuKey: this.$router.history.current.query.menuKey
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}

.remarkTip {
  color: #ff142f;
  margin-top: 19px;
}

/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
.tooltip-header {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin: 10px 0;
  line-height: 20px;
}
/deep/.el-table .cell {
  width: 100% !important;
}
</style>
